module.exports = __webpack_public_path__ + "img/trash.697d059b.svg";